window.CollabSeason.ready.then(function(){

(function () {
  var reduce = window.matchMedia(window.CollabSeason.text("sfce63bfb9eba")).matches;
  var member = document.documentElement.classList.contains('member');
  var rtl = document.documentElement.dir === 'rtl' ? -1 : 1;
  var fine = window.matchMedia(window.CollabSeason.text("s19b4d67507d6")).matches;
  var LOCK = window.CollabSeason.text("scaaad0ebc01b_html");
  var deals = window.CollabSeason.homePhotoPlan(window.CollabSeason.deals.slice(0,10));
  var BARS = [72, 58, 40, 66];
  var ROUTE = Object.fromEntries(deals.map(d=>[d.id,d.route]));
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function title(d) { return member ? esc(d.name) : esc(d.hint).replace(/(\S+)$/, window.CollabSeason.text("s96f75bbb726e_html") + LOCK + '</span>'); }
  function byId(id) { for (var i = 0; i < deals.length; i++) if (deals[i].id === id) return deals[i]; return deals[0]; }
  function hay(d) { var logo = !member && window.CollabSeason.logos[d.id]; return [d.hint, d.line, d.ask, d.cat, d.type, d.pay, member ? d.name : logo ? logo.alt : ''].join(' ').toLowerCase(); }
  function matches(d, words) { var h = hay(d); return words.every(function (w) { return h.indexOf(w) > -1; }); }
  function wordsOf(s) { return s.toLowerCase().split(/\s+/).filter(Boolean); }

  // count a number up inside a text, for example "£400 per creator"
  function countUp(el, ms) {
    if (reduce || !el) return;
    var txt = el.getAttribute('data-txt') || el.textContent;
    el.setAttribute('data-txt', txt);
    var m = txt.match(/\d[\d,]*/);
    if (!m) return;
    var n = parseInt(m[0].replace(/,/g, ''), 10), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / (ms || 800)), e = 1 - Math.pow(1 - k, 3);
      el.textContent = txt.replace(m[0], Math.round(n * e).toLocaleString('en-GB'));
      if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
    }
    requestAnimationFrame(step);
  }

  // headline words rise in
  var h1 = document.getElementById('h1');
  var hw = h1.textContent.split(' ');
  h1.innerHTML = hw.map(function (w, i) {
    var inner = window.CollabSeason.text("s680edec39fab_html") + (0.05 + i * 0.06) + 's">' + esc(w) + '</b>';
    return window.CollabSeason.text("s295559607cc3_html") + inner + '</span>';
  }).join(' ');

  // the wall
  function wCard(d, copy) {
    return window.CollabSeason.decorateWallLogo(window.CollabSeason.text("s322aeba46d34_html") + d.id + '"' + (copy ? window.CollabSeason.text("s2358ce9eb135") : '') + '>' +
      window.CollabSeason.text("sa0cf6748f66e_html") + d.img + window.CollabSeason.text("sad9261903775_html") + esc(d.pay) + '</span></span>' +
      window.CollabSeason.text("s8c3f42e4f924_html") + esc(d.line) + window.CollabSeason.text("s0436df52ec86_html") + title(d) + '</span></button>', d);
  }
  function loop(list) { return list.map(function (d) { return wCard(d, false); }).join(''); }
  var wallPhotos = window.CollabSeason.homeWallPhotos;
  var wallDeals = deals.length ? wallPhotos.map(function(photo,i){return Object.assign({},deals[i % deals.length],{img:photo});}) : [];
  document.getElementById('rowTrack').innerHTML = '';
  var COLS = [0,1,2].map(function(col){return wallDeals.map(function(_,i){return i;}).filter(function(i){return i%3===col;});});
  document.getElementById('wallCols').innerHTML = COLS.map(function (c) {
    return window.CollabSeason.text("seec9e9e9cd49_html") + loop(c.filter(function(i){return i<wallDeals.length;}).map(function (i) { return wallDeals[i]; })) + '</div></div>';
  }).join('');
  // QA round 3 (R3-09): a collab that repeats on the wall is reachable once by keyboard, and the skip link lands on search
  var wallSeen = {};
  document.querySelectorAll('#wallCols .w-card').forEach(function (card) {
    var id = card.getAttribute('data-id');
    if (wallSeen[id]) { card.setAttribute('aria-hidden', 'true'); card.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = -1; }); }
    wallSeen[id] = true;
  });
  var skipLink = document.querySelector('.skip-link'), heroSearch = document.getElementById('q');
  if (skipLink && heroSearch) skipLink.addEventListener('click', function (e) { e.preventDefault(); heroSearch.focus(); });
  var wallDragged = false;
  document.querySelectorAll('.w-card').forEach(function (b) {
    b.addEventListener('click', function (e) { if (wallDragged || e.target.closest('.cs-card-logo')) return; openDeal(byId(b.getAttribute('data-id')), b.querySelector('img'), deals); });
  });

  // one loop moves the wall; scrolling speeds it up, hovering slows it
  function Belt(track, axis, speed, dir) {
    this.track = track; this.axis = axis; this.speed = speed; this.dir = dir; this.cur = speed;
    this.off = 0; this.half = 0; this.hold = false; this.drag = null; this.measure();
  }
  Belt.prototype.measure = function () {
    var children=this.track.children;
    this.half=children.length?(this.axis==='x'?this.track.scrollWidth:this.track.scrollHeight):0;

  };
  Belt.prototype.tick = function (dt, boost) {
    if(this.lock || !this.half || !this.track.children.length)return;
    if(!this.drag){
      var want=this.hold?0:this.speed*(1+boost);
      this.cur+=(want-this.cur)*Math.min(1,dt*4);
      this.off+=this.cur*dt*(this.dir>0?1:-1);
    }
    var gap=parseFloat(getComputedStyle(this.track)[this.axis==='x'?'columnGap':'rowGap'])||0;
    var size=function(el){return (this.axis==='x'?el.offsetWidth:el.offsetHeight)+gap;}.bind(this);
    var first=this.track.firstElementChild,step=size(first),moves=0;
    if(!step)return;
    while(this.off<=-step && moves++<this.track.children.length){this.off+=step;this.track.appendChild(first);first=this.track.firstElementChild;step=size(first);}
    moves=0;
    while(this.off>0 && moves++<this.track.children.length){var last=this.track.lastElementChild;this.track.insertBefore(last,this.track.firstElementChild);this.off-=size(last);}
    this.track.style.transform=this.axis==='x'?'translate3d('+(this.off*rtl)+'px,0,0)':'translate3d(0,'+this.off+'px,0)';

  };
  var belts = [];
  var rowTrack = document.getElementById('rowTrack');
  var rowBelt = new Belt(rowTrack, 'x', 26, -1); belts.push(rowBelt);
  document.querySelectorAll('.col-track').forEach(function (tr, i) { belts.push(new Belt(tr, 'y', [24, 20, 28][i], i === 1 ? 1 : -1)); });
  var wallCards = Array.prototype.slice.call(document.querySelectorAll('.w-card'));
  wallCards.forEach(function(card){card.querySelector('img').loading='eager';});
  var wallColumns = Array.prototype.slice.call(document.querySelectorAll('.col-track'));
  function layoutWall() {
    var desktop = window.matchMedia(window.CollabSeason.text("s88f91c085d4d")).matches;
    wallCards.forEach(function(card,i){(desktop?wallColumns[i%3]:rowTrack).appendChild(card);});
    belts.forEach(function(b){b.off=0;b.track.style.transform='none';b.measure();});
  }
  layoutWall();
  var tickBelt = null;
  var wall = document.getElementById('wall');
  wall.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') belts.forEach(function (b) { if (b !== tickBelt) b.hold = true; }); });
  wall.addEventListener('pointerleave', function () { belts.forEach(function (b) { b.hold = false; }); });
  // keyboard users: the wall stops while a card has focus, and the focused card moves fully into view
  wall.addEventListener('focusin', function (e) {
    var card = e.target.closest('.w-card'); if (!card) return;
    belts.forEach(function (b) { b.hold = true; b.lock = true; b.cur = 0; });
    var belt = belts.filter(function (b) { return b.track.contains(card); })[0]; if (!belt) return;
    var clip = belt.track.parentElement; clip.scrollTop = 0; clip.scrollLeft = 0;
    var x = belt.axis === 'x', box = clip.getBoundingClientRect(), r = card.getBoundingClientRect();
    var lo = x ? box.left : box.top, hi = x ? box.right : box.bottom, a = x ? r.left : r.top, z = x ? r.right : r.bottom, shift = 0;
    if (a < lo + 8) shift = lo + 8 - a; else if (z > hi - 8) shift = hi - 8 - z;
    if (shift) { belt.off += x ? shift * rtl : shift; belt.track.style.transform = x ? 'translate3d(' + (belt.off * rtl) + 'px,0,0)' : 'translate3d(0,' + belt.off + 'px,0)'; }
    card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
  wall.addEventListener('focusout', function (e) { if (wall.contains(e.relatedTarget)) return; belts.forEach(function (b) { b.hold = false; b.lock = false; }); });
  // the phone row can be dragged sideways
  var row = document.getElementById('wallRow'), sx = 0, so = 0;
  row.addEventListener('pointerdown', function (e) { rowBelt.drag = true; wallDragged = false; sx = e.clientX; so = rowBelt.off; });
  row.addEventListener('pointermove', function (e) {
    if (!rowBelt.drag) return;
    var d = e.clientX - sx; if (Math.abs(d) > 6) { wallDragged = true; try { row.setPointerCapture(e.pointerId); } catch (x) {} }
    rowBelt.off = so + d * rtl;
  });
  function rowEnd() { rowBelt.drag = null; setTimeout(function () { wallDragged = false; }, 50); }
  row.addEventListener('pointerup', rowEnd); row.addEventListener('pointercancel', rowEnd);
  var boost = 0, lastY = window.scrollY, lastT = performance.now();
  function frame(now) {
    var dt = Math.min(0.05, (now - lastT) / 1000); lastT = now;
    var y = window.scrollY, v = Math.abs(y - lastY) / Math.max(dt, 0.001); lastY = y;
    boost = Math.max(boost * 0.92, Math.min(5, v / 300));
    if (!reduce) belts.forEach(function (b) { b.tick(dt, boost); });
    requestAnimationFrame(frame);
  }
  window.addEventListener('load', function () { belts.forEach(function (b) { b.measure(); }); });
  window.addEventListener('resize', layoutWall);
  if (document.fonts) document.fonts.ready.then(function () { belts.forEach(function (b) { b.measure(); }); });
  requestAnimationFrame(frame);

  // the hub grid
  var grid = document.getElementById('grid');
  deals.forEach(function (d) {
    var a = document.createElement('div');
    a.className = 'card'; a.setAttribute('data-id', d.id); a.style.setProperty('--c', d.c);
    a.innerHTML = window.CollabSeason.text("s6df3fed0ad28_html") + d.cut + window.CollabSeason.text("s2c639080fe2a_html") +
      '<span class="sticker" data-sticker-kind="'+d.stickerKind+'">'+window.CollabSeasonStickers.html(d)+'</span>' +
      (member ? '' : window.CollabSeason.text("s36da2e34c881_html") + LOCK + window.CollabSeason.text("s5ed19ab7b9e3_html")) + '</div>' +
      window.CollabSeason.text("s6a8268f24df7_html") + esc(d.line) + '</span></div>' +
      window.CollabSeason.text("s570947c194ed_html") + esc(d.line) + window.CollabSeason.text("se5c2c383823a_html") + title(d) + window.CollabSeason.text("s2adcf8381901_html") + esc(d.ask) + '</p>' +
      window.CollabSeason.text("s94643d51ec78_html") + esc(d.pay) + window.CollabSeason.text("sb90886af4d8c_html") + esc(d.pay) + '</span></a>' +
      ((member || window.CollabSeason.canSave) && window.csSaveHTML ? window.csSaveHTML(d.id, member ? d.name : d.hint, !member) : '');
    window.CollabSeason.decorateCardLogo(a,d);
    a.addEventListener('click', function (e) { if(e.target.closest('.save,.cs-card-logo'))return; e.preventDefault(); openDeal(d, null, shownDeals()); });
    if (fine && !reduce) {
      a.addEventListener('pointermove', function (e) {
        var r = a.getBoundingClientRect();
        a.style.setProperty('--px', (((e.clientX - r.left) / r.width - 0.5) * 22) + 'px');
        a.style.setProperty('--py', (((e.clientY - r.top) / r.height - 0.5) * 12) + 'px');
      });
    }
    grid.appendChild(a);
  });
  if (!member) {
    var more = document.createElement('div');
    more.className = 'more';
    more.innerHTML = window.CollabSeason.text("s4a05e0508c28_html") +
      window.CollabSeason.text("s5c3203a1ad0c_html")+window.CollabSeason.routes.join+window.CollabSeason.text("s628c8cbc08ba_html");
    grid.appendChild(more);
  }
  var items = Array.prototype.slice.call(grid.children);
  function shownDeals() { return items.filter(function (el) { return el.getAttribute('data-id') && !el.classList.contains('gone'); }).map(function (el) { return byId(el.getAttribute('data-id')); }); }

  // Home pills count the whole open catalogue and open that Hub filter.
  // Search and the ten-card preview keep their existing behaviour.
  var q = document.getElementById('q'), q2 = document.getElementById('q2');
  var count = document.getElementById('count'), none = document.getElementById('none'), clear = document.getElementById('clear');
  var type = 'all', cat = null;
  function ok(d, w, ty, ca) { return (ty === 'all' || d.type === ty) && (!ca || d.cat === ca) && matches(d, w); }
  function apply(animate) {
    var w = wordsOf(q2.value);
    var first = items.map(function (el) { return el.getBoundingClientRect(); });
    var shown = 0;
    items.forEach(function (el) {
      var id = el.getAttribute('data-id');
      if (!id) { el.classList.toggle('gone', type !== 'all' || !!cat || w.length > 0); return; }
      var good = ok(byId(id), w, type, cat);
      el.classList.toggle('gone', !good);
      el.classList.remove('o2', 'o3');
      if (good) { if (shown % 2 === 1) el.classList.add('o2'); if (shown % 3 === 1) el.classList.add('o3'); shown++; }
    });
    count.textContent = window.CollabSeason.text("s7282e1fbb2c6") + shown + window.CollabSeason.text("sa4282e4b2298") + window.CollabSeason.deals.length + window.CollabSeason.text("sb8d38306c4dd");
    none.hidden = shown > 0;
    clear.hidden = !(type !== 'all' || cat || w.length);
    document.querySelectorAll('#chips .chip').forEach(function (c) {
      var t2 = c.getAttribute('data-t'), c2 = c.getAttribute('data-c');
      c.setAttribute('aria-pressed', String(t2 === 'all'));
      var n = c.querySelector('.n');
      if (n) {
        var k = window.CollabSeason.deals.filter(function (d) { return t2 ? t2 === 'all' || d.type === t2 : d.cat === c2; }).length;
        n.textContent = k;
        n.hidden = (t2 === 'events' || t2 === 'direct') && k === 0;
        c.disabled = k === 0;
      }
    });
    if (reduce || animate === false) { items.forEach(function (el) { if (!el.classList.contains('gone')) el.classList.add('in'); }); return; }
    items.forEach(function (el, k) {
      if (el.classList.contains('gone')) return;
      var b = el.getBoundingClientRect(), a = first[k];
      el.classList.add('in');
      if (!a.width) { el.animate([{ opacity: 0, transform: 'scale(0.96)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'cubic-bezier(0.2,0.8,0.2,1)' }); return; }
      var dx = a.left - b.left, dy = a.top - b.top;
      if (dx || dy) el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 600, easing: 'cubic-bezier(0.2,0.8,0.2,1)' });
    });
  }
  document.querySelectorAll('#chips .chip').forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.disabled) return;
      var t2 = c.getAttribute('data-t'), c2 = c.getAttribute('data-c');
      var destination = new URL(window.CollabSeason.routes.hub, location.origin);
      if (t2 && t2 !== 'all') destination.searchParams.set('t', t2);
      if (c2) destination.searchParams.set('c', c2);
      if (q2.value.trim()) destination.searchParams.set('q', q2.value.trim());
      destination.hash = 'deals';
      window.csGo(destination.href);
    });
  });
  clear.addEventListener('click', function () { type = 'all'; cat = null; q2.value = ''; apply(); });
  q2.addEventListener('input', function () { apply(); });
  document.getElementById('hubSearch').addEventListener('submit', function (e) { e.preventDefault(); q2.blur(); });
  function goHub() { document.getElementById('deals').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  document.querySelectorAll('[data-go]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = b.getAttribute('data-go');
      // QA rerun 21 Oct: the 10 sample cards cannot hold every type, so these chips open the Members Hub filter
      var destination = new URL(window.CollabSeason.routes.hub, location.origin);
      destination.searchParams.set(['paid', 'gifted', 'affiliate'].indexOf(g) > -1 ? 't' : 'c', g);
      destination.hash = 'deals';
      window.csGo(destination.href);
    });
  });
  apply(false);
  items.forEach(function (el) { el.classList.remove('in'); });

  // grid or list
  document.querySelectorAll('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      var list = b.getAttribute('data-view') === 'list';
      if (grid.classList.contains('list') === list) return;
      document.querySelectorAll('[data-view]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
      if (reduce) { grid.classList.toggle('list', list); return; }
      grid.classList.add('swap');
      setTimeout(function () {
        grid.classList.toggle('list', list);
        grid.classList.remove('swap');
        items.forEach(function (el, k) { if (!el.classList.contains('gone')) el.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: k * 35, easing: 'cubic-bezier(0.2,0.8,0.2,1)', fill: 'backwards' }); });
      }, 200);
    });
  });

  // live results under the hero search
  var results = document.getElementById('results'), active = -1, hits = [];
  function mark(s, w) {
    var out = esc(s);
    w.forEach(function (x) { if (x.length > 1) out = out.replace(new RegExp('(' + x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i'), '<mark>$1</mark>'); });
    return out;
  }
  function render() {
    var w = wordsOf(q.value);
    hits = deals.filter(function (d) { return matches(d, w); });
    var head = w.length ? (hits.length ? hits.length + (hits.length === 1 ? window.CollabSeason.text("s2b7917cdf188") : window.CollabSeason.text("sb8d38306c4dd")) : '') : window.CollabSeason.text("s71f578dae67f");
    var html = head ? window.CollabSeason.text("se98390fe356b_html") + head + '</div>' : '';
    if (!hits.length) html += window.CollabSeason.text("s3c414abdc004_html");
    hits.slice(0, 4).forEach(function (d, i) {
      var name = member ? mark(d.name, w) : mark(d.hint, w) + LOCK;
      html += window.CollabSeason.text("s940af4688e32_html") + i + window.CollabSeason.text("s0c38c165910a_html") + d.img + window.CollabSeason.text("seadddf27c6a1_html") + esc(d.line) + '</small><strong>' + name + window.CollabSeason.text("sa3f92b6a3191_html") + esc(d.pay) + '</span></a>';
    });
    if (hits.length) html += window.CollabSeason.text("s360902ae8864_html") + hits.length + window.CollabSeason.text("s689a78dac453_html");
    results.innerHTML = html; results.hidden = false; q.setAttribute('aria-expanded', 'true'); active = -1;
    results.querySelectorAll('.r-item').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); hide(); openDeal(hits[+a.getAttribute('data-i')], a.querySelector('img'), hits); });
    });
    var all = results.querySelector('.r-all');
    if (all) all.addEventListener('click', submitHero);
  }
  function hide() { results.hidden = true; q.setAttribute('aria-expanded', 'false'); }
  function move(k) {
    var opts = Array.prototype.slice.call(results.querySelectorAll('.r-item, .r-all'));
    if (!opts.length) return;
    active = (active + k + opts.length) % opts.length;
    opts.forEach(function (o, i) { o.classList.toggle('on', i === active); });
  }
  function submitHero(e) { if (e) e.preventDefault(); typing = false; hide(); q2.value = q.value; type = 'all'; cat = null; apply(false); goHub(); }
  results.addEventListener('mousedown', function (e) { e.preventDefault(); });
  q.addEventListener('focus', function () { typing = false; q.placeholder = window.CollabSeason.text("s9fcbb7dde372"); render(); });
  q.addEventListener('input', render);
  q.addEventListener('blur', function () { setTimeout(hide, 120); });
  q.addEventListener('keydown', function (e) {
    if (e.key === window.CollabSeason.text("s9660fb862202")) { e.preventDefault(); move(1); }
    else if (e.key === window.CollabSeason.text("s12204d1d8ab8")) { e.preventDefault(); move(-1); }
    else if (e.key === window.CollabSeason.text("s037c968467aa")) { hide(); }
    else if (e.key === window.CollabSeason.text("sdc8659db6d41") && active > -1) { e.preventDefault(); var o = results.querySelectorAll('.r-item, .r-all')[active]; if (o) o.click(); }
  });
  document.getElementById('heroSearch').addEventListener('submit', submitHero);

  // the hero search shows what you can look for
  // Example words are typed in the page language (QA 25 Oct item 4).
  var demoWords = { es: ['cuidado facial', 'punto', 'fragancias'], pt: ['cuidados com a pele', 'tricô', 'perfumes'], fr: ['soin du visage', 'maille', 'parfums'], de: ['Hautpflege', 'Strickmode', 'Düfte'], it: ['cura della pelle', 'maglieria', 'profumi'], pl: ['pielęgnacja', 'dzianina', 'perfumy'], ar: ['العناية بالبشرة', 'التريكو', 'العطور'] };
  var typing = !reduce, demo = (demoWords[(document.documentElement.lang || 'en').slice(0, 2)] || ['skincare', 'knitwear', 'fragrance']).concat([window.CollabSeason.text("sed9c6348be96")]), wi = 0;
  function type1(word, k, back) {
    if (!typing) return;
    q.placeholder = word.slice(0, k) || window.CollabSeason.text("s9fcbb7dde372");
    if (!back && k < word.length) return setTimeout(function () { type1(word, k + 1, false); }, 85);
    if (!back) return setTimeout(function () { type1(word, k, true); }, 1500);
    if (k > 0) return setTimeout(function () { type1(word, k - 1, true); }, 35);
    wi = (wi + 1) % demo.length;
    setTimeout(function () { type1(demo[wi], 1, false); }, 900);
  }
  if (typing) setTimeout(function () { type1(demo[0], 1, false); }, 2200);

  // price switch: monthly or yearly. Shopify shows each visitor their own currency; the preview shows UK prices
  var PR = { gbp: window.CollabSeason.prices }; 
  var per = 'month', cur = 'gbp';
  function price() {
    var p = window.CollabSeason.prices; if(!p) return; var big = document.getElementById('pBig');
    if(!big)return; big.textContent = p.s + (per === 'month' ? p.intro : p.year);
    big.classList.remove('roll'); void big.offsetWidth; big.classList.add('roll');
    document.getElementById('pLine').textContent = per === 'month' ? window.CollabSeason.text("sd75b0c4ab7e6") + p.s + p.after + window.CollabSeason.text("se16fe374656d") : window.CollabSeason.text("se48c679af3bb");
    document.getElementById('pBtn').textContent = per === 'month' ? window.CollabSeason.text("s5fb0ebfdf5df") + p.s + p.intro : window.CollabSeason.text("s295883e5817d") + p.s + p.year + window.CollabSeason.text("sdec967749ab2");
    document.getElementById('pNote').textContent = window.CollabSeason.text("s07640b14287e") + p.tax;
    document.querySelectorAll('[data-p]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-p') === per)); });
  }
  document.querySelectorAll('[data-p]').forEach(function (b) { b.addEventListener('click', function () { per = b.getAttribute('data-p'); price(); }); });

  document.addEventListener('cs:prices',price);
  var lastBand = document.getElementById('last');

  // opportunity page: a black wipe, then the cut out on its colour, with previous and next and a swipe on a phone
  var sheet = document.getElementById('sheet'), sPop = document.getElementById('sPop'), sInfo = document.getElementById('sInfo');
  var sPic = document.getElementById('sPic'), wipe = document.getElementById('wipe');
  var nav = deals, cur1 = 0;
  function fill(d) {
    sPic.style.setProperty('--c', d.c);
    sPop.src = d.cut;
    window.CollabSeason.detailLogo(document.getElementById('sLine'),d);
    document.getElementById('sLine').textContent = d.line;
    document.getElementById('sTitle').innerHTML = title(d);
    document.getElementById('sAsk').textContent = d.ask;
    var pay = document.getElementById('sPay'); pay.removeAttribute('data-txt'); pay.textContent = d.pay;
    document.getElementById('sFacts').innerHTML = d.facts.map(function (f, k) {
      var v = member || f[1] ? window.CollabSeason.text("sbab1ea39739e_html") + esc(f[1]) + '</span>'
        : window.CollabSeason.text("s116cec08b447_html") + BARS[k] + window.CollabSeason.text("s34e8e4828433_html");
      return window.CollabSeason.text("s26ad4ecb1260_html") + f[0] + '</dt><dd>' + v + '</dd></div>';
    }).join('');
    var full = window.CollabSeason.text("scb614055a7e7_html") + d.url + window.CollabSeason.text("s3a7e10016c18_html");
    document.getElementById('sAct').innerHTML = member
      ? window.CollabSeason.text("s4db7cb832bc3_html") + d.open + window.CollabSeason.text("sb56c78314cc0_html") + (window.csSaveHTML ? window.csSaveHTML(d.id, d.name, true) : '') + full + '</div>'
      : window.CollabSeason.text("s8a26432540c9_html") + LOCK + window.CollabSeason.text("s22a5046f94e9_html") +
        window.CollabSeason.text("s4db7cb832bc3_html")+window.CollabSeason.routes.join+window.CollabSeason.text("s334fd427b6c2_html") + (window.CollabSeason.canSave ? window.csSaveHTML(d.id,d.hint,true,true) : '') + full + '</div>';
    document.getElementById('sPos').textContent = (cur1 + 1) + window.CollabSeason.text("sa4282e4b2298") + nav.length;
    sInfo.classList.remove('play'); void sInfo.offsetWidth; sInfo.classList.add('play');
    countUp(pay, 700);
  }
  function show(d, dir) {
    cur1 = Math.max(0, nav.indexOf(d));
    fill(d);
    sheet.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    if (!reduce && sPop.animate) sPop.animate([{ opacity: 0, transform: window.CollabSeason.text("s317656d3a802").replace('-50%', rtl < 0 ? '50%' : '-50%') + (dir * 60 * rtl) + window.CollabSeason.text("sa88bc4c36918") }, { opacity: 1, transform: window.CollabSeason.text("sacdbbc6ebe42").replace('-50%', rtl < 0 ? '50%' : '-50%') }], { duration: 600, easing: 'cubic-bezier(0.2,0.8,0.2,1)' });
  }
  function step(k) { if (nav.length > 1) show(nav[(cur1 + k + nav.length) % nav.length], k); }
  function reveal() {
    sheet.classList.remove('open'); void sheet.offsetWidth; sheet.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    dockState();
  }
  function openDeal(d, from, list) {
    nav = list && list.indexOf(d) > -1 ? list : deals;
    cur1 = nav.indexOf(d);
    fill(d);
    sheet.scrollTop = 0;
    // QA rerun 21 Oct: the open panel gets its own Back step, as on the Members Hub
    if (!(history.state && history.state.csSheet)) history.pushState({ csSheet: 1 }, '');
    if (reduce) { reveal(); return; }
    wipe.classList.remove('go'); void wipe.offsetWidth; wipe.classList.add('go');
    setTimeout(reveal, 500);
  }
  function closeSheet(fromBack) { sheet.classList.remove('open'); document.documentElement.style.overflow = ''; dockState(); if (fromBack !== true && history.state && history.state.csSheet) history.back(); }
  window.addEventListener('popstate', function () { if (sheet.classList.contains('open')) closeSheet(true); });
  document.getElementById('close').addEventListener('click', closeSheet);
  document.getElementById('sPrev').addEventListener('click', function () { step(-1); });
  document.getElementById('sNext').addEventListener('click', function () { step(1); });
  document.addEventListener('keydown', function (e) {
    if (!sheet.classList.contains('open')) return;
    if (e.key === window.CollabSeason.text("s037c968467aa")) closeSheet();
    if (e.key === window.CollabSeason.text("s8e2f7ffbbdb9")) step(rtl);
    if (e.key === window.CollabSeason.text("s48e61e2dd0a2")) step(-rtl);
  });
  var px = null;
  sPic.addEventListener('pointerdown', function (e) { if (!e.target.closest('.s-nav')) px = e.clientX; });
  sPic.addEventListener('pointerup', function (e) { if (px === null) return; var d = e.clientX - px; px = null; if (Math.abs(d) > 50) step((d < 0 ? 1 : -1) * rtl); });

  // reveals, the steps line, the reading line and the join bar
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('in');
      var tag = en.target.querySelector('.ph .pay-tag'); if (tag) countUp(tag);
      io.unobserve(en.target);
    });
  }, { threshold: 0.15 });
  items.forEach(function (c, i) { c.style.setProperty('--d', ((i % 4) * 0.08) + 's'); io.observe(c); });
  document.querySelectorAll('.step').forEach(function (el) { io.observe(el); });
  var top = document.getElementById('top'), stepList = document.getElementById('stepList');
  var steps = Array.prototype.slice.call(document.querySelectorAll('.step'));
  var dock = document.getElementById('dock'), heroEl = document.getElementById('hero');
  var heroIn = true, lastIn = false;
  function dockState() { if(!dock) return; var on = !member && !heroIn && !lastIn && !sheet.classList.contains('open'); dock.classList.toggle('on', on); dock.inert = !on; }
  new IntersectionObserver(function (es) { heroIn = es[0].isIntersecting; dockState(); }, { rootMargin: window.CollabSeason.text("s7059d4b29f57") }).observe(heroEl);
  if(lastBand) new IntersectionObserver(function (es) { lastIn = es[0].isIntersecting; dockState(); }).observe(lastBand);
  function onScroll() {
    var y = window.scrollY, max = document.documentElement.scrollHeight - innerHeight;
    top.classList.toggle('line', y > 8);
    top.style.setProperty('--read', max > 0 ? (y / max).toFixed(4) : 0);
    if (!member) {
      var r = stepList.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (innerHeight * 0.75 - r.top) / r.height));
      stepList.style.setProperty('--p', p.toFixed(3));
      steps.forEach(function (s, i) { s.classList.toggle('lit', p >= i / steps.length + 0.02); });
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

window.CollabSeason.finishPage();
});
